import {isEmpty} from 'lodash';
import {Resolve} from '@angular/router';
import {Injectable} from '@angular/core';
import {Keys, StorageService} from '../service/storage.service';
import {LenderDetailsService} from '../service/lender-details.service';

@Injectable()
export class LenderResidenceInfoResolver implements Resolve<{ proofType: string, proofNumber: string } | null> {
    private readonly storageService: StorageService;
    private readonly lenderDetailsService: LenderDetailsService;

    constructor(storageService: StorageService, lenderDetailsService: LenderDetailsService) {
        this.storageService = storageService;
        this.lenderDetailsService = lenderDetailsService;
    }

    public async resolve(): Promise<{ proofType: string, proofNumber: string } | null> {
        const lenderId = this.storageService.getItem(Keys.LENDER_ID);
        const response = await this.lenderDetailsService.getLenderDetails(lenderId);
        const lender = response.lender_info;
        if (isEmpty(lender.correspondence_address) || isEmpty(lender.correspondence_address.proofs)) {
            return null;
        }
        return {
            proofType: lender.correspondence_address.proofs[0].proofType,
            proofNumber: lender.correspondence_address.proofs[0].proofNumber
        };
    }
}
